export const Vendor = {
  FLOTEX: 1,
  ORLEN: 2,
  BP: 3,
  PBS: 4,
  DNBNORD: 5,
  PKO: 6,
  LOTOS: 7,
  AMIC: 8,
  SHELL: 9,
  MILLENNIUM_BANK: 10,
  MOYA: 11,
  ING_BANK: 12,
  PRZELEWY24: 13,
  BP_FLP: 14,
  TEST_CARD_VENDOR1: 999,
  getText(value) {
    let text = ''
    switch (value) {
      case Vendor.FLOTEX:
        text = 'FLOTEX'
        break
      case Vendor.ORLEN:
        text = 'ORLEN'
        break
      case Vendor.BP:
        text = 'BP'
        break
      case Vendor.PBS:
        text = 'PBS'
        break
      case Vendor.DNBNORD:
        text = 'DNB NORD'
        break
      case Vendor.PKO:
        text = 'PKO'
        break
      case Vendor.LOTOS:
        text = 'LOTOS'
        break
      case Vendor.AMIC:
        text = 'AMIC'
        break
      case Vendor.SHELL:
        text = 'SHELL'
        break
      case Vendor.MILLENNIUM_BANK:
        text = 'MILLENNIUM'
        break
      case Vendor.MOYA:
        text = 'MOYA'
        break
      case Vendor.ING_BANK:
        text = 'ING'
        break
      case Vendor.PRZELEWY24:
        text = 'Przelewy24'
        break
      case Vendor.BP_FLP:
        text = 'BP FLP'
        break
      case Vendor.TEST_CARD_VENDOR1:
        text = 'nieznany'
        break
    }
    return text
  }
}

export const CardType = {
  CAR: 'S',
  DRIVER: 'K',
  getText(value) {
    let text = ''
    switch (value) {
      case CardType.CAR:
        text = 'na samochód'
        break
      case CardType.DRIVER:
        text = 'na kierowcę'
        break
    }
    return text
  }
}

export const CardVehicleType = {
  PASSENGER_CAR: 'O',
  LORRY: 'C',
  getText(value) {
    let text = ''
    switch (value) {
      case CardVehicleType.PASSENGER_CAR:
        text = 'osobowy'
        break
      case CardVehicleType.LORRY:
        text = 'ciężarowy'
        break
    }
    return text
  }
}

export const CustomerEconomicActivity = {
  SP_PRAWA_HANDLOWEGO: 1,
  OS_FIZ_DGOSP: 2,
  SP_CYWILNA: 3,
  getText(value) {
    let text = ''
    switch (value) {
      case CustomerEconomicActivity.SP_PRAWA_HANDLOWEGO:
        text = 'spółka prawa handlowego'
        break
      case CustomerEconomicActivity.OS_FIZ_DGOSP:
        text = 'osoba fizyczna prowadząca działalność gospodarczą'
        break
      case CustomerEconomicActivity.SP_CYWILNA:
        text = 'spółka cywilna'
        break
    }
    return text
  }
}

export const ContractSignMethod = {
  PAPER: 1,
  AUTENTI: 2,
  getText(value) {
    let text = ''
    switch (value) {
      case ContractSignMethod.PAPER:
        text = 'dokument papierowy'
        break
      case ContractSignMethod.AUTENTI:
        text = 'dokument elektroniczny - Autenti'
        break
    }
    return text
  }
}

export const ProductGroupOrlen = {
  OLEJ_NAPEDOWY: '01',
  OLEJ_NAPEDOWY_VERVA: '02',
  BENZYNA_EUROSUPER_95: '03',
  BENZYNA_VERVA_98: '05',
  LPG: '06',
  BIO_PALIWA: '08',
  OLEJE_SILNIKOWE: '11',
  PLYNY_EKSPLOATACYJNE: '12',
  OLEJE_SMAROWE: '13',
  POZOSTALE_PROD_NAFTOWE: '14',
  USLUGI_SAMOCHODOWE: '20',
  USLUGI_POZOSTALE: '21',
  USLUGA_LADOWANIA_EV: '24',
  KOSMETYKI_SAMOCHODOWE: '29',
  AKCESORIA_SAMOCHODOWE: '30',
  OPLATY_PARKINGOWE: '35',
  OPLATY_ZA_AUTOSTRADY: '36',
  MOBIPARKING_OPLATA_PARKINGOWA: '37',
  ARTYKULY_POZOSTALE: '40',
  VIATOLLAUTO_OPLATA_DROGOWA: '41',
  VIATOLLAUTO_USLUGA_FINANSOWA: '42',
  VIABOX_KAUCJA: '43',
  VIABOX_ZWROT_KAUCJI: '44',
  PRZEJAZD_AUTOSTRADA: '49',
  ARTYKULY_PRZEMYSLOWE: '50',
  ARTYKULY_SPOZYWCZE: '51',
  NAPOJE_BEZALKOHOLOWE: '52',
  WYROBY_TYTONIOWE: '53',
  NAPOJE_ALKOHOLOWE: '54',
  STOP_CAFE: '55',
  OPLATA_PLASTIKI: '56',
  KAUCJA_OPAKOWANIA: '57',
  DUPLIKAT_KARTY: '80',
  ADBLUE: '81',
  MOBIPARKING_ABONAMENT: '85',
  MOBIUSLUGI: '86',
  getText(value) {
    let text = ''
    switch (value) {
      case ProductGroupOrlen.OLEJ_NAPEDOWY:
        text = 'OLEJ NAPĘDOWY'
        break
      case ProductGroupOrlen.OLEJ_NAPEDOWY_VERVA:
        text = 'OLEJ NAPĘDOWY VERVA'
        break
      case ProductGroupOrlen.BENZYNA_EUROSUPER_95:
        text = 'BENZYNA EUROSUPER 95'
        break
      case ProductGroupOrlen.BENZYNA_VERVA_98:
        text = 'BENZYNA VERVA 98'
        break
      case ProductGroupOrlen.LPG:
        text = 'LPG'
        break
      case ProductGroupOrlen.BIO_PALIWA:
        text = 'BIO PALIWA'
        break
      case ProductGroupOrlen.OLEJE_SILNIKOWE:
        text = 'OLEJE SILNIKOWE'
        break
      case ProductGroupOrlen.PLYNY_EKSPLOATACYJNE:
        text = 'PŁYNY EKSPLOATACYJNE'
        break
      case ProductGroupOrlen.OLEJE_SMAROWE:
        text = 'OLEJE SMAROWE'
        break
      case ProductGroupOrlen.POZOSTALE_PROD_NAFTOWE:
        text = 'POZOSTAŁE PROD. NAFTOWE'
        break
      case ProductGroupOrlen.USLUGI_SAMOCHODOWE:
        text = 'USŁUGI SAMOCHODOWE'
        break
      case ProductGroupOrlen.USLUGI_POZOSTALE:
        text = 'USŁUGI POZOSTAŁE'
        break
      case ProductGroupOrlen.USLUGA_LADOWANIA_EV:
        text = 'ŁADOWANIE EN. ELEKTRYCZNĄ'
        break
      case ProductGroupOrlen.KOSMETYKI_SAMOCHODOWE:
        text = 'KOSMETYKI SAMOCHODOWE'
        break
      case ProductGroupOrlen.AKCESORIA_SAMOCHODOWE:
        text = 'AKCESORIA SAMOCHODOWE'
        break
      case ProductGroupOrlen.OPLATY_PARKINGOWE:
        text = 'OPŁATY PARKINGOWE'
        break
      case ProductGroupOrlen.OPLATY_ZA_AUTOSTRADY:
        text = 'OPŁATY ZA AUTOSTRADY'
        break
      case ProductGroupOrlen.MOBIPARKING_OPLATA_PARKINGOWA:
        text = 'OPŁATA ZA KORZYSTANIE ZE STREF PŁATNEGO PARKOWANIA'
        break
      case ProductGroupOrlen.ARTYKULY_POZOSTALE:
        text = 'ARTYKUŁY POZOSTAŁE'
        break
      case ProductGroupOrlen.VIATOLLAUTO_OPLATA_DROGOWA:
        text = 'VIATOLL/AUTO - OPŁATA DROGOWA'
        break
      case ProductGroupOrlen.VIATOLLAUTO_USLUGA_FINANSOWA:
        text = 'VIATOLL/AUTO - USŁUGA FINANSOWA'
        break
      case ProductGroupOrlen.VIABOX_KAUCJA:
        text = 'VIABOX - KAUCJA'
        break
      case ProductGroupOrlen.VIABOX_ZWROT_KAUCJI:
        text = 'VIABOX - ZWROT KAUCJI'
        break
      case ProductGroupOrlen.PRZEJAZD_AUTOSTRADA:
        text = 'OPŁATY ZA AUTOSTRADY'
        break
      case ProductGroupOrlen.ARTYKULY_PRZEMYSLOWE:
        text = 'ARTYKUŁY PRZEMYSŁOWE'
        break
      case ProductGroupOrlen.ARTYKULY_SPOZYWCZE:
        text = 'ARTYKUŁY SPOŻYWCZE'
        break
      case ProductGroupOrlen.NAPOJE_BEZALKOHOLOWE:
        text = 'NAPOJE BEZALKOHOLOWE'
        break
      case ProductGroupOrlen.WYROBY_TYTONIOWE:
        text = 'WYROBY TYTONIOWE'
        break
      case ProductGroupOrlen.NAPOJE_ALKOHOLOWE:
        text = 'NAPOJE ALKOHOLOWE'
        break
      case ProductGroupOrlen.STOP_CAFE:
        text = 'STOP CAFÉ'
        break
      case ProductGroupOrlen.OPLATA_PLASTIKI:
        text = 'OPŁATA PLASTIKI'
        break
      case ProductGroupOrlen.KAUCJA_OPAKOWANIA:
        text = 'KAUCJA OPAKOWANIA'
        break
      case ProductGroupOrlen.DUPLIKAT_KARTY:
        text = 'DUPLIKAT KARTY'
        break
      case ProductGroupOrlen.ADBLUE:
        text = 'ADBLUE'
        break
      case ProductGroupOrlen.MOBIPARKING_ABONAMENT:
        text = 'USŁUGA MOBIPARKING'
        break
      case ProductGroupOrlen.MOBIUSLUGI:
        text = 'MOBIUSŁUGI'
        break
    }
    return text
  }
}

export const ProductGroupBP = {
  BP_ULTIMATE_98_LTR: '2',
  ULTIMATE_DIESEL_LTR: '3',
  BEZOLOW_95_LTR: '4',
  BEZOLOW_98_LTR: '5',
  ADBLUE__LTR: '6',
  ADBLUE__SZT: '7',
  AUTO_MYJNIA_SZT: '10',
  MYJNIA_RECZNA_SZT: '11',
  ODKURZACZ_SZT: '12',
  EV_NORMAL: '13',
  EV_FAST: '14',
  GAZ_BUTLE_SZT: '15',
  EV_ULTRA_FAST: '18',
  PLYN_DO_CHLODNIC_SZT: '20',
  PLYN_DO_SPRYS_BP: '21',
  PLYN_DO_SPRYSK_SZT: '22',
  AKCESORIA_SAM_SZT: '25',
  OPONY_SZT: '26',
  AKUMULATOR_SZT: '27',
  CZESCI_ZAMIENNE_SZT: '28',
  SERWIS_SAM_SZT: '29',
  AKCESORIA_7_SZT: '31',
  DIESEL_PREM_LTR: '32',
  BEZOLOW_95_PREM_LTR: '33',
  BEZOLOW_98_PREM_LTR: '34',
  OLEJE_SILNIKOWE: '37',
  OLEJ_NAPEDOWY_LTR: '39',
  SCREENWASH: '40',
  ART_SPOZYWCZE22_SZT: '42',
  ART_SPOZYWCZE7_SZT: '43',
  ART_SPOZYWCZE3_SZT: '44',
  ART_SPOZYWCZE0_SZT: '45',
  SLODYCZE22_SZT: '47',
  SLODYCZE7_SZT: '48',
  NAPOJE22_SZT: '49',
  NAPOJE7_SZT: '50',
  GAZ_PLYNNY_LTR: '51',
  GAZETY_7_SZT: '52',
  GAZETY_0_SZT: '53',
  WYROBY_TYTONIOWE_SZT: '54',
  EV_INITIAL_PAYMENT: '55',
  BISTRO22_SZT: '56',
  BISTRO7_SZT: '57',
  BISTRO_0_SZT: '58',
  BISTRO_ZW_SZT: '59',
  EV_USAGE_TIME: '60',
  OPL_AUTOSTRADY_SZT: '61',
  EUROVINNETE_SZT: '62',
  ART_NIESPOZYW0_SZT: '63',
  ART_NIESPOZYW7_SZT: '64',
  ART_NIESPOZYW22_SZT: '65',
  ART_NIESPOZYW3_SZT: '67',
  ART_NIESPOZYWZW_SZT: '68',
  ART_DZIEC7_SZT: '69',
  ADBLUE_LTR: '70',
  ADBLUE_SZT: '71',
  BISTRO: '72',
  DODATKI_DO_PALIW_SZT: '74',
  KARTY_TEL_DOLAD_SZT: '75',
  GAZETY_22_SZT: '76',
  SMARY_SZT: '77',
  ZAROWKI_SZT: '78',
  WYCIERACZKI_SZT: '79',
  PLYN_PRZECIWZAM_SZT: '80',
  PLYN_HAMULCOWY_SZT: '81',
  MAPY22_SZT: '82',
  MAPY7_SZT: '83',
  MAPY0_SZT: '84',
  OPL_DROGOWE2_SZT: '93',
  OPL_DROGOWE_SZT: '95',
  OPL_PARKING_SZT: '97',
  INNE_PRODUKTYTIS_PL_SZT: '99',
  getText(value) {
    let text = ''
    switch (value) {
      case ProductGroupBP.BP_ULTIMATE_98_LTR:
        text = 'BP ULTIMATE 98   LTR'
        break
      case ProductGroupBP.ULTIMATE_DIESEL_LTR:
        text = 'ULTIMATE DIESEL  LTR'
        break
      case ProductGroupBP.BEZOLOW_95_LTR:
        text = 'BEZOLOW 95       LTR'
        break
      case ProductGroupBP.BEZOLOW_98_LTR:
        text = 'BEZOLOW 98       LTR'
        break
      case ProductGroupBP.ADBLUE__LTR:
        text = 'ADBLUE'
        break
      case ProductGroupBP.ADBLUE__SZT:
        text = 'ADBLUE'
        break
      case ProductGroupBP.AUTO_MYJNIA_SZT:
        text = 'AUTO MYJNIA      SZT'
        break
      case ProductGroupBP.MYJNIA_RECZNA_SZT:
        text = 'MYJNIA RECZNA    SZT'
        break
      case ProductGroupBP.ODKURZACZ_SZT:
        text = 'ODKURZACZ        SZT'
        break
      case ProductGroupBP.EV_NORMAL:
        text = 'EV NORMALNE ŁADOWANIE'
        break
      case ProductGroupBP.EV_FAST:
        text = 'EV SZYBKIE ŁADOWANIE'
        break
      case ProductGroupBP.GAZ_BUTLE_SZT:
        text = 'GAZ BUTLE        SZT'
        break
      case ProductGroupBP.EV_ULTRA_FAST:
        text = 'EV ULTRA SZYBKIE ŁADOWANIE'
        break
      case ProductGroupBP.PLYN_DO_CHLODNIC_SZT:
        text = 'PLYN DO CHLODNIC SZT'
        break
      case ProductGroupBP.PLYN_DO_SPRYS_BP:
        text = 'PLYN DO SPRYS BP'
        break
      case ProductGroupBP.PLYN_DO_SPRYSK_SZT:
        text = 'PLYN DO SPRYSK   SZT'
        break
      case ProductGroupBP.AKCESORIA_SAM_SZT:
        text = 'AKCESORIA SAM.   SZT'
        break
      case ProductGroupBP.OPONY_SZT:
        text = 'OPONY            SZT'
        break
      case ProductGroupBP.AKUMULATOR_SZT:
        text = 'AKUMULATOR       SZT'
        break
      case ProductGroupBP.CZESCI_ZAMIENNE_SZT:
        text = 'CZESCI ZAMIENNE  SZT'
        break
      case ProductGroupBP.SERWIS_SAM_SZT:
        text = 'SERWIS SAM          SZT'
        break
      case ProductGroupBP.AKCESORIA_7_SZT:
        text = 'AKCESORIA 7%     SZT'
        break
      case ProductGroupBP.DIESEL_PREM_LTR:
        text = 'DIESEL PREMIUM LTR'
        break
      case ProductGroupBP.BEZOLOW_95_PREM_LTR:
        text = 'BENZYNA PREMIUM LTR'
        break
      case ProductGroupBP.BEZOLOW_98_PREM_LTR:
        text = 'BENZYNA 98 PREMIUM LTR'
        break
      case ProductGroupBP.OLEJE_SILNIKOWE:
        text = 'OLEJE SILNIKOWE'
        break
      case ProductGroupBP.OLEJ_NAPEDOWY_LTR:
        text = 'OLEJ NAPEDOWY    LTR'
        break
      case ProductGroupBP.SCREENWASH:
        text = 'SCREENWASH'
        break
      case ProductGroupBP.ART_SPOZYWCZE22_SZT:
        text = 'ART. SPOZYWCZE22 SZT'
        break
      case ProductGroupBP.ART_SPOZYWCZE7_SZT:
        text = 'ART. SPOZYWCZE7  SZT'
        break
      case ProductGroupBP.ART_SPOZYWCZE3_SZT:
        text = 'ART. SPOZYWCZE3  SZT'
        break
      case ProductGroupBP.ART_SPOZYWCZE0_SZT:
        text = 'ART. SPOZYWCZE0  SZT'
        break
      case ProductGroupBP.SLODYCZE22_SZT:
        text = 'SLODYCZE22       SZT'
        break
      case ProductGroupBP.SLODYCZE7_SZT:
        text = 'SLODYCZE7        SZT'
        break
      case ProductGroupBP.NAPOJE22_SZT:
        text = 'NAPOJE22         SZT'
        break
      case ProductGroupBP.NAPOJE7_SZT:
        text = 'NAPOJE7          SZT'
        break
      case ProductGroupBP.GAZ_PLYNNY_LTR:
        text = 'GAZ PLYNNY       LTR'
        break
      case ProductGroupBP.GAZETY_7_SZT:
        text = 'GAZETY 7%  SZT'
        break
      case ProductGroupBP.GAZETY_0_SZT:
        text = 'GAZETY 0%  SZT'
        break
      case ProductGroupBP.WYROBY_TYTONIOWE_SZT:
        text = 'WYROBY TYTONIOWE SZT'
        break
      case ProductGroupBP.EV_INITIAL_PAYMENT:
        text = 'EV OPŁATA STARTOWA'
        break
      case ProductGroupBP.BISTRO22_SZT:
        text = 'BISTRO22         SZT'
        break
      case ProductGroupBP.BISTRO7_SZT:
        text = 'BISTRO7          SZT'
        break
      case ProductGroupBP.BISTRO_0_SZT:
        text = 'BISTRO 0         SZT'
        break
      case ProductGroupBP.BISTRO_ZW_SZT:
        text = 'BISTRO ZW        SZT'
        break
      case ProductGroupBP.EV_USAGE_TIME:
        text = 'EV CZAS UŻYCIA'
        break
      case ProductGroupBP.OPL_AUTOSTRADY_SZT:
        text = 'OPL. AUTOSTRADY  SZT'
        break
      case ProductGroupBP.EUROVINNETE_SZT:
        text = 'EUROVINNETE      SZT'
        break
      case ProductGroupBP.ART_NIESPOZYW0_SZT:
        text = 'ART. NIESPOZYW0  SZT'
        break
      case ProductGroupBP.ART_NIESPOZYW7_SZT:
        text = 'ART. NIESPOZYW7  SZT'
        break
      case ProductGroupBP.ART_NIESPOZYW22_SZT:
        text = 'ART. NIESPOZYW22 SZT'
        break
      case ProductGroupBP.ART_NIESPOZYW3_SZT:
        text = 'ART. NIESPOZYW3% SZT'
        break
      case ProductGroupBP.ART_NIESPOZYWZW_SZT:
        text = 'ART. NIESPOZYWZW SZT'
        break
      case ProductGroupBP.ART_DZIEC7_SZT:
        text = 'ART. DZIEC7%   SZT'
        break
      case ProductGroupBP.ADBLUE_LTR:
        text = 'ADBLUE           LTR'
        break
      case ProductGroupBP.ADBLUE_SZT:
        text = 'ADBLUE           SZT'
        break
      case ProductGroupBP.BISTRO:
        text = 'BISTRO'
        break
      case ProductGroupBP.DODATKI_DO_PALIW_SZT:
        text = 'DODATKI DO PALIW SZT'
        break
      case ProductGroupBP.KARTY_TEL_DOLAD_SZT:
        text = 'KARTY TEL / DOLAD   SZT'
        break
      case ProductGroupBP.GAZETY_22_SZT:
        text = 'GAZETY 22%  SZT'
        break
      case ProductGroupBP.SMARY_SZT:
        text = 'SMARY  SZT'
        break
      case ProductGroupBP.ZAROWKI_SZT:
        text = 'ZAROWKI       SZT'
        break
      case ProductGroupBP.WYCIERACZKI_SZT:
        text = 'WYCIERACZKI     SZT'
        break
      case ProductGroupBP.PLYN_PRZECIWZAM_SZT:
        text = 'PLYN PRZECIWZAM SZT'
        break
      case ProductGroupBP.PLYN_HAMULCOWY_SZT:
        text = 'PŁYN HAMULCOWY SZT'
        break
      case ProductGroupBP.MAPY22_SZT:
        text = 'MAPY22%   SZT'
        break
      case ProductGroupBP.MAPY7_SZT:
        text = 'MAPY7%   SZT'
        break
      case ProductGroupBP.MAPY0_SZT:
        text = 'MAPY0%   SZT'
        break
      case ProductGroupBP.OPL_DROGOWE2_SZT:
        text = 'OPL. DROGOWE SZT'
        break
      case ProductGroupBP.OPL_DROGOWE_SZT:
        text = 'OPL. DROGOWE SZT'
        break
      case ProductGroupBP.OPL_PARKING_SZT:
        text = 'OPL. PARKING SZT'
        break
      case ProductGroupBP.INNE_PRODUKTYTIS_PL_SZT:
        text = 'INNE PRODUKTY/TIS PL SZT'
        break
    }
    return text
  }
}

export const ProductGroupAmic = {
  KEROSENE: '103',
  DIESEL: '107',
  DIESEL_PREMIUM: '114',
  LPG: '154',
  METHANE: '155',
  BIOFUEL: '161',
  PB80: '180',
  PB95: '195',
  PB95_PREMIUM: '196',
  PB98: '198',
  ADDBLUE: '210',
  MOTOR_OILS: '236',
  FUEL_ADDITIVES: '238',
  ADDBLUE_PACKAGE: '240',
  GASES: '279',
  OTHER_AUTO_LIQUIDS: '295',
  CHEMICAL_PRODUCTS_FOR_CARS: '296',
  CAR_ACCESSORIES: '297',
  PHARMACY_PRODUCTS: '306',
  PRINTED_PRODUCTS: '307',
  ELECTRIC_PRODUCTS: '309',
  HOUSEHOLD_PRODUCTS: '311',
  COSMETICS: '315',
  GROCERIES: '328',
  GASTRONOMY: '330',
  CONFECTIONERY: '332',
  SOFT_DRINKS: '334',
  CAR_WASH: '343',
  FINANCIAL_SERVICES: '346',
  ROAD_SERVICES: '347',
  COMMUNICATION_SERVICES: '350',
  RENTAL_SERVICES: '351',
  OTHER_SERVICES: '354',
  getText(value) {
    let text = ''
    switch (value) {
      case ProductGroupAmic.KEROSENE:
        text = 'NAFTA OCZYSZCZONA'
        break
      case ProductGroupAmic.DIESEL:
        text = 'DIESEL'
        break
      case ProductGroupAmic.DIESEL_PREMIUM:
        text = 'PRO ON - DIESEL'
        break
      case ProductGroupAmic.LPG:
        text = 'LPG'
        break
      case ProductGroupAmic.METHANE:
        text = 'METAN'
        break
      case ProductGroupAmic.BIOFUEL:
        text = 'BIOPALIWA'
        break
      case ProductGroupAmic.PB80:
        text = 'PB80'
        break
      case ProductGroupAmic.PB95:
        text = 'PB95'
        break
      case ProductGroupAmic.PB95_PREMIUM:
        text = 'PRO 95 - BENZYNA'
        break
      case ProductGroupAmic.PB98:
        text = 'PB98'
        break
      case ProductGroupAmic.ADDBLUE:
        text = 'ADBLUE'
        break
      case ProductGroupAmic.MOTOR_OILS:
        text = 'OLEJE SILNIKOWE'
        break
      case ProductGroupAmic.FUEL_ADDITIVES:
        text = 'DODATKI DO PALIW'
        break
      case ProductGroupAmic.ADDBLUE_PACKAGE:
        text = 'ADDBLUE SZT'
        break
      case ProductGroupAmic.GASES:
        text = 'BUTLE GAZOWE'
        break
      case ProductGroupAmic.OTHER_AUTO_LIQUIDS:
        text = 'INNE PŁYNY SAMOCHODOWE'
        break
      case ProductGroupAmic.CHEMICAL_PRODUCTS_FOR_CARS:
        text = 'CHEMIA SAMOCHODOWA'
        break
      case ProductGroupAmic.CAR_ACCESSORIES:
        text = 'AKCESORIA SAMOCHODOWE'
        break
      case ProductGroupAmic.PHARMACY_PRODUCTS:
        text = 'PRODUKTY APTECZNE'
        break
      case ProductGroupAmic.PRINTED_PRODUCTS:
        text = 'PRODUKTY DRUKOWANE'
        break
      case ProductGroupAmic.ELECTRIC_PRODUCTS:
        text = 'ARTYKUŁY ELEKTRYCZNE/ELEKTRONICZNE'
        break
      case ProductGroupAmic.HOUSEHOLD_PRODUCTS:
        text = 'PRODUKTY AGD'
        break
      case ProductGroupAmic.COSMETICS:
        text = 'KOSMETYKI'
        break
      case ProductGroupAmic.GROCERIES:
        text = 'ARTYKUŁY SPOŻYWCZE'
        break
      case ProductGroupAmic.GASTRONOMY:
        text = 'GASTRONOMIA'
        break
      case ProductGroupAmic.CONFECTIONERY:
        text = 'CUKIERNIA'
        break
      case ProductGroupAmic.SOFT_DRINKS:
        text = 'NAPOJE BEZALKOHOLOWE'
        break
      case ProductGroupAmic.CAR_WASH:
        text = 'MYJNIA'
        break
      case ProductGroupAmic.FINANCIAL_SERVICES:
        text = 'USŁUGI FINANSOWE'
        break
      case ProductGroupAmic.ROAD_SERVICES:
        text = 'OPŁATY DROGOWE'
        break
      case ProductGroupAmic.COMMUNICATION_SERVICES:
        text = 'USŁUGI KOMUNIKACYJNE'
        break
      case ProductGroupAmic.RENTAL_SERVICES:
        text = 'USŁUGI NAJMU'
        break
      case ProductGroupAmic.OTHER_SERVICES:
        text = 'INNE USŁUGI'
        break
    }
    return text
  }
}

export const ProductGroupShell = {
  THIRD_PARTY_FEE: '2',
  SET_UP_FEE: '3',
  EMERGENCY_FEE: '6',
  CARD_FEE: '7',
  TMF: '10',
  TUNELE_MOSTY: '11',
  AUTOSTRADY: '12',
  PROMY: '13',
  PODATEK_DROGOWY: '14',
  ODPRAWA_CELNA: '15',
  EUROVIGNETTE: '16',
  TRANSPORT_KOLEJOWY: '17',
  ELECTRIC_CHARGE: '18',
  TMF_ZWOLNIONE_Z_VAT: '19',
  V_POWER_NITRO_95: '20',
  PB_98: '21',
  FUELSAVE_95: '22',
  UNIWERSALNA_95: '23',
  V_POWER_NITRO_RACING_100: '24',
  ETYLINA_94: '25',
  ETYLINA_98: '26',
  BENZYNA_BEZOLOWIOWA: '27',
  LNG: '28',
  CNG: '29',
  FUELSAVE_DIESEL: '30',
  OLEJ_NAPEDOWY: '31',
  OLEJ_NAPEDOWY_Z_MNIEJSZA_ZAWARTOSCIA_SIARKI: '32',
  V_POWER_NITRO_DIESEL: '33',
  GAZ_PLYNNY: '34',
  OLEJ_NAPEDOWY_DO_DWU_SUWA: '35',
  INNE_PALIWA: '36',
  OLEJ_SILNIKOWY_NIE_SAMOCHODOWY: '37',
  AD_BLUE_BULK: '38',
  AD_BLUE_PACKED: '39',
  PŁYNY_KOSMETYKI_SAMOCHODOWE: '40',
  OLEJE_SILNIKOWE: '41',
  OLEJE_SILNIKOWE_2: '42',
  AKCESORIA_SAM_8_VAT: '43',
  ODMRAZACZE: '46',
  ZAWOR_PALIWA: '47',
  TBA_USZLACHETNIACZ_PALIWA: '50',
  OPONY: '51',
  AKUMULATORY: '52',
  AKCESORIA_SAMOCHODOWE: '53',
  WIPER_BLADES: '54',
  AKCESORIA_SAMOCHODOWE_2: '55',
  AKCESORIA_SAMOCHODOWE_3: '56',
  SAFETY_ACCESSORIES: '57',
  MYJNIA_PROGRAM_3: '60',
  CZYSZCZENIE_ZBIORNIKA: '61',
  WYMIANA_OLEJU: '62',
  PUBLIC_TRANSPORT: '63',
  TRUCKWASH: '64',
  MYJNIA_ODKURZACZ: '65',
  NAPRAWY_DORAZNE: '66',
  PARKING: '67',
  NAPRAWY_ZWOLNIONE_Z_VAT: '69',
  SKLEP_ART_23_VAT: '70',
  FAST_FOOD_23_VAT: '71',
  NAPOJE_BEZALKOHOLOWE: '72',
  NAPOJE_ALKOHOLOWE: '73',
  PAPIEROSY_TYTON: '74',
  FAST_FOOD_8: '75',
  SKLEP_ART_8_VAT: '76',
  SKLEP_ART_5_VAT: '77',
  SKLEP_ART_0_VAT: '78',
  SKLEP_ART: '79',
  INNE: '80',
  WYNAJEM_SAMOCHODU: '81',
  HOTEL: '82',
  RESTAURACJA_8_VAT: '83',
  ELECTRIC_CHARGE_TIME: '87',
  TELEPHONE: '89',
  USLUGI_ZWOLNIONE_Z_VAT: '90',
  SKLEP_ART_ZWOLNIONE_Z_VAT: '92',
  ZWROT_VAT: '98',
  ELECTRIC_CHARGE_FAST: '486',
  ELECTRIC_CHARGE_CONN_FEE: '489',
  ELECTRIC_CHARGE_TR_FEE: '601',
  FS01: 'FS01',
  FS02: 'FS02',
  FS09: 'FS09',
  NFS01: 'NFS01',
  NFS02: 'NFS02',
  NFS03: 'NFS03',
  NFS04: 'NFS04',
  NFS05: 'NFS05',
  NFS06: 'NFS06',
  getText(value) {
    let text = ''
    switch (value) {
      case ProductGroupShell.THIRD_PARTY_FEE:
        text = 'OPŁATY ADMINISTRACYJNE'
        break
      case ProductGroupShell.SET_UP_FEE:
        text = 'OPŁATA AKTYWACYJNA'
        break
      case ProductGroupShell.EMERGENCY_FEE:
        text = 'PROWIZJA POWIĄZANA Z KARTĄ'
        break
      case ProductGroupShell.CARD_FEE:
        text = 'OPŁATA ZA KARTĘ'
        break
      case ProductGroupShell.TMF:
        text = 'TMF (TUNELE, AUTOSTR., PROMY)'
        break
      case ProductGroupShell.TUNELE_MOSTY:
        text = 'TUNELE/MOSTY'
        break
      case ProductGroupShell.AUTOSTRADY:
        text = 'AUTOSTRADY'
        break
      case ProductGroupShell.PROMY:
        text = 'PROMY'
        break
      case ProductGroupShell.PODATEK_DROGOWY:
        text = 'PODATEK DROGOWY'
        break
      case ProductGroupShell.ODPRAWA_CELNA:
        text = 'ODPRAWA CELNA'
        break
      case ProductGroupShell.EUROVIGNETTE:
        text = 'EUROVIGNETTE'
        break
      case ProductGroupShell.TRANSPORT_KOLEJOWY:
        text = 'TRANSPORT KOLEJOWY'
        break
      case ProductGroupShell.ELECTRIC_CHARGE:
        text = 'ŁADOWARKA - KWH'
        break
      case ProductGroupShell.TMF_ZWOLNIONE_Z_VAT:
        text = 'TMF ZWOLNIONE Z VAT'
        break
      case ProductGroupShell.V_POWER_NITRO_95:
        text = 'V-POWER NITRO+ 95'
        break
      case ProductGroupShell.PB_98:
        text = 'PB 98'
        break
      case ProductGroupShell.FUELSAVE_95:
        text = 'FUELSAVE 95'
        break
      case ProductGroupShell.UNIWERSALNA_95:
        text = 'UNIWERSALNA 95'
        break
      case ProductGroupShell.V_POWER_NITRO_RACING_100:
        text = 'V POWER NITRO+ RACING 100'
        break
      case ProductGroupShell.ETYLINA_94:
        text = 'ETYLINA 94'
        break
      case ProductGroupShell.ETYLINA_98:
        text = 'ETYLINA 98'
        break
      case ProductGroupShell.BENZYNA_BEZOLOWIOWA:
        text = 'BENZYNA BEZOŁOWIOWA'
        break
      case ProductGroupShell.LNG:
        text = 'LNG'
        break
      case ProductGroupShell.CNG:
        text = 'CNG'
        break
      case ProductGroupShell.FUELSAVE_DIESEL:
        text = 'FUELSAVE DIESEL'
        break
      case ProductGroupShell.OLEJ_NAPEDOWY:
        text = 'OLEJ NAPĘDOWY'
        break
      case ProductGroupShell.OLEJ_NAPEDOWY_Z_MNIEJSZA_ZAWARTOSCIA_SIARKI:
        text = 'OLEJ NAPĘDOWY Z MNIEJSZĄ ZAWARTOŚCIĄ SIARKI'
        break
      case ProductGroupShell.V_POWER_NITRO_DIESEL:
        text = 'V-POWER NITRO+ DIESEL'
        break
      case ProductGroupShell.GAZ_PLYNNY:
        text = 'GAZ PŁYNNY'
        break
      case ProductGroupShell.OLEJ_NAPEDOWY_DO_DWU_SUWA:
        text = 'OLEJ NAPĘDOWY DO DWU SUWA'
        break
      case ProductGroupShell.INNE_PALIWA:
        text = 'INNE PALIWA'
        break
      case ProductGroupShell.OLEJ_SILNIKOWY_NIE_SAMOCHODOWY:
        text = 'OLEJ SILNIKOWY (NIE SAMOCHODOWY)'
        break
      case ProductGroupShell.AD_BLUE_BULK:
        text = 'AD BLUE - DYSTRYBUTOR'
        break
      case ProductGroupShell.AD_BLUE_PACKED:
        text = 'AD BLUE - OPAKOWANIE'
        break
      case ProductGroupShell.PŁYNY_KOSMETYKI_SAMOCHODOWE:
        text = 'PŁYNY, KOSMETYKI SAMOCHODOWE'
        break
      case ProductGroupShell.OLEJE_SILNIKOWE:
        text = 'OLEJE SILNIKOWE'
        break
      case ProductGroupShell.OLEJE_SILNIKOWE_2:
        text = 'OLEJE SILNIKOWE'
        break
      case ProductGroupShell.AKCESORIA_SAM_8_VAT:
        text = 'AKCESORIA SAM. 8% VAT'
        break
      case ProductGroupShell.ODMRAZACZE:
        text = 'ODMRAŻACZE'
        break
      case ProductGroupShell.ZAWOR_PALIWA:
        text = 'ZAWÓR PALIWA'
        break
      case ProductGroupShell.TBA_USZLACHETNIACZ_PALIWA:
        text = 'TBA - USZLACHETNIACZ PALIWA'
        break
      case ProductGroupShell.OPONY:
        text = 'OPONY'
        break
      case ProductGroupShell.AKUMULATORY:
        text = 'AKUMULATORY'
        break
      case ProductGroupShell.AKCESORIA_SAMOCHODOWE:
        text = 'AKCESORIA SAMOCHODOWE'
        break
      case ProductGroupShell.WIPER_BLADES:
        text = 'WYCIERACZKI SAMOCHODOWE'
        break
      case ProductGroupShell.AKCESORIA_SAMOCHODOWE_2:
        text = 'AKCESORIA SAMOCHODOWE'
        break
      case ProductGroupShell.AKCESORIA_SAMOCHODOWE_3:
        text = 'AKCESORIA SAMOCHODOWE'
        break
      case ProductGroupShell.SAFETY_ACCESSORIES:
        text = 'AKCESORIA OCHRONNE'
        break
      case ProductGroupShell.MYJNIA_PROGRAM_3:
        text = 'MYJNIA PROGRAM 3'
        break
      case ProductGroupShell.CZYSZCZENIE_ZBIORNIKA:
        text = 'CZYSZCZENIE ZBIORNIKA'
        break
      case ProductGroupShell.WYMIANA_OLEJU:
        text = 'WYMIANA OLEJU'
        break
      case ProductGroupShell.PUBLIC_TRANSPORT:
        text = 'TRANSPORT PUBLICZNY'
        break
      case ProductGroupShell.TRUCKWASH:
        text = 'MYJNIA TIR'
        break
      case ProductGroupShell.MYJNIA_ODKURZACZ:
        text = 'MYJNIA/ODKURZACZ'
        break
      case ProductGroupShell.NAPRAWY_DORAZNE:
        text = 'NAPRAWY DORAŹNE'
        break
      case ProductGroupShell.PARKING:
        text = 'PARKING'
        break
      case ProductGroupShell.NAPRAWY_ZWOLNIONE_Z_VAT:
        text = 'NAPRAWY ZWOLNIONE Z VAT'
        break
      case ProductGroupShell.SKLEP_ART_23_VAT:
        text = 'SKLEP ART. 23% VAT'
        break
      case ProductGroupShell.FAST_FOOD_23_VAT:
        text = 'FAST FOOD 23% VAT'
        break
      case ProductGroupShell.NAPOJE_BEZALKOHOLOWE:
        text = 'NAPOJE BEZALKOHOLOWE'
        break
      case ProductGroupShell.NAPOJE_ALKOHOLOWE:
        text = 'NAPOJE ALKOHOLOWE'
        break
      case ProductGroupShell.PAPIEROSY_TYTON:
        text = 'PAPIEROSY/TYTOŃ'
        break
      case ProductGroupShell.FAST_FOOD_8:
        text = 'FAST FOOD 8%'
        break
      case ProductGroupShell.SKLEP_ART_8_VAT:
        text = 'SKLEP ART. 8% VAT'
        break
      case ProductGroupShell.SKLEP_ART_5_VAT:
        text = 'SKLEP ART. 5% VAT'
        break
      case ProductGroupShell.SKLEP_ART_0_VAT:
        text = 'SKLEP ART. 0% VAT'
        break
      case ProductGroupShell.SKLEP_ART:
        text = 'ARTYKUŁY SKLEPOWE'
        break
      case ProductGroupShell.INNE:
        text = 'INNE'
        break
      case ProductGroupShell.WYNAJEM_SAMOCHODU:
        text = 'WYNAJEM SAMOCHODU'
        break
      case ProductGroupShell.HOTEL:
        text = 'HOTEL'
        break
      case ProductGroupShell.RESTAURACJA_8_VAT:
        text = 'RESTAURACJA 8% VAT'
        break
      case ProductGroupShell.ELECTRIC_CHARGE_TIME:
        text = 'ŁADOWARKA - MINUTY'
        break
      case ProductGroupShell.TELEPHONE:
        text = 'TELEFON'
        break
      case ProductGroupShell.USLUGI_ZWOLNIONE_Z_VAT:
        text = 'USŁUGI ZWOLNIONE Z VAT'
        break
      case ProductGroupShell.SKLEP_ART_ZWOLNIONE_Z_VAT:
        text = 'SKLEP ART. ZWOLNIONE Z VAT'
        break
      case ProductGroupShell.ZWROT_VAT:
        text = 'ZWROT VAT'
        break
      case ProductGroupShell.ELECTRIC_CHARGE_FAST:
        text = 'ŁADOWARKA DC - KWH'
        break
      case ProductGroupShell.ELECTRIC_CHARGE_CONN_FEE:
        text = 'ŁADOWARKA - PODŁĄCZENIE'
        break
      case ProductGroupShell.ELECTRIC_CHARGE_TR_FEE:
        text = 'ŁADOWARKA - PROWIZJA'
        break
      case ProductGroupShell.FS01:
        text = 'WSZYSTKIE PALIWA'
        break
      case ProductGroupShell.FS02:
        text = 'WSZYSTKIE OLEJE NAPĘDOWE'
        break
      case ProductGroupShell.FS09:
        text = 'WSZYSTKIE BENZYNY'
        break
      case ProductGroupShell.NFS01:
        text = 'AKCESORIA I USŁUGI'
        break
      case ProductGroupShell.NFS02:
        text = 'AKCESORIA, PRODUKTY NIEPALIWOWE I USŁUGI'
        break
      case ProductGroupShell.NFS03:
        text = 'OPŁATY DROGOWE'
        break
      case ProductGroupShell.NFS04:
        text = 'ART.SPOŻYWCZE'
        break
      case ProductGroupShell.NFS05:
        text = 'MYJNIA'
        break
      case ProductGroupShell.NFS06:
        text = 'AKCESORIA PODSTAWOWE'
        break
    }
    return text
  }
}

export const ProductGroupMoya = {
  ON: '11',
  PB95: '12',
  PB98: '13',
  LPG: '14',
  ON_POWER: '15',
  EV: '18',
  AD_BLUE_OLD: '19',
  MOYA_FLUIDS: '21',
  OLEJE_SILNIKOWE: '22',
  AD_BLUE_CONT: '23',
  FLUIDS: '24',
  AD_BLUE: '25',
  PLYNY_EKSPLOATACYJNE: '26',
  ART_PRZEMYSŁOWE: '27',
  KOSMETYKI_SAMOCHODOWE: '28',
  AKCESORIA_SAMOCHODOWE: '29',
  SCALE: '31',
  PARKING: '32',
  HIGHWAY_FEES: '33',
  MYJNIA_ODKURZACZ: '34',
  CAR_SERVICE: '35',
  getText(value) {
    let text = ''
    switch (value) {
      case ProductGroupMoya.ON:
        text = 'ON'
        break
      case ProductGroupMoya.PB95:
        text = 'PB95'
        break
      case ProductGroupMoya.PB98:
        text = 'PB98'
        break
      case ProductGroupMoya.LPG:
        text = 'LPG'
        break
      case ProductGroupMoya.ON_POWER:
        text = 'ON POWER'
        break
      case ProductGroupMoya.EV:
        text = 'ŁADOWANIE EN. ELEKTRYCZNĄ'
        break
      case ProductGroupMoya.AD_BLUE_OLD:
        text = 'ADBLUE DYSTR.'
        break
      case ProductGroupMoya.MOYA_FLUIDS:
        text = 'PŁYN DO SPRYSKIWACZY'
        break
      case ProductGroupMoya.OLEJE_SILNIKOWE:
        text = 'OLEJE SILNIKOWE'
        break
      case ProductGroupMoya.AD_BLUE_CONT:
        text = 'ADBLUE'
        break
      case ProductGroupMoya.FLUIDS:
        text = 'PŁYN DO SPRYSKIWACZY DYSTR.'
        break
      case ProductGroupMoya.AD_BLUE:
        text = 'ADBLUE DYSTR.'
        break
      case ProductGroupMoya.PLYNY_EKSPLOATACYJNE:
        text = 'PŁYNY EKSPLOATACYJNE'
        break
      case ProductGroupMoya.ART_PRZEMYSŁOWE:
        text = 'ARTYKUŁY PRZEMYSŁOWE'
        break
      case ProductGroupMoya.KOSMETYKI_SAMOCHODOWE:
        text = 'KOSMETYKI SAMOCHODOWE'
        break
      case ProductGroupMoya.AKCESORIA_SAMOCHODOWE:
        text = 'AKCESORIA SAMOCHODOWE'
        break
      case ProductGroupMoya.SCALE:
        text = 'WAGA'
        break
      case ProductGroupMoya.PARKING:
        text = 'OPŁATY PARKINGOWE'
        break
      case ProductGroupMoya.HIGHWAY_FEES:
        text = 'OPŁATY DROGOWE'
        break
      case ProductGroupMoya.MYJNIA_ODKURZACZ:
        text = 'MYJNIA I ODKURZACZ'
        break
      case ProductGroupMoya.CAR_SERVICE:
        text = 'USŁUGI SAMOCHODOWE'
        break
    }
    return text
  }
}

export const BlankNewCustomerStatus = {
  REQ_ACC_CUSTOMER: 5,
  REQ_ACC_PH: 10,
  REQ_ACC_MANAGER: 15,
  REQ_ACC_BIURO: 20,
  FINISHED: 25,
  SUSPENDED: 30,
  getText(value) {
    let text = ''
    switch (value) {
      case BlankNewCustomerStatus.REQ_ACC_CUSTOMER:
        text = 'do akceptacji - klient'
        break
      case BlankNewCustomerStatus.REQ_ACC_PH:
        text = 'do akceptacji - PH'
        break
      case BlankNewCustomerStatus.REQ_ACC_MANAGER:
        text = 'do akceptacji - Kierownik DH'
        break
      case BlankNewCustomerStatus.REQ_ACC_BIURO:
        text = 'do akceptacji - Biuro'
        break
      case BlankNewCustomerStatus.FINISHED:
        text = 'rozpatrzony'
        break
      case BlankNewCustomerStatus.SUSPENDED:
        text = 'wstrzymany'
        break
    }
    return text
  }
}

export function getConstantsList(object) {
  let list = []
  for (const property in object) {
    let value = object[property]
    if (typeof value === 'function') {
      continue
    }
    if (typeof value === 'object') {
      continue
    }
    // console.log(`${value}: ${object . getText(value)}`)
    list.push({
      value: value,
      text: object.getText(value)
    })
  }
  return list
}
